import { useLocation } from 'react-router-dom';
import InstallPWAButton from './InstallPWAButton';

const PWAInstallGate = () => {
  const { pathname } = useLocation();

  const shouldShow =
    pathname === '/login' || pathname.startsWith('/app');

  if (!shouldShow) return null;

  return <InstallPWAButton />;
};

export default PWAInstallGate;